import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

function deveIgnorarCache(url: string): boolean {
  const u = url.toLowerCase();
  return u.includes('/api/extrato')
    || u.includes('/listarextratos')
    || u.includes('/listarextratoscomlinhasextratos');
}

export const PerformanceInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  if (req.method === 'GET') {
    const semCache = deveIgnorarCache(req.url);
    const modifiedReq = req.clone({
      setHeaders: {
        'Cache-Control': semCache
          ? 'no-cache, no-store, must-revalidate'
          : 'max-age=300',
        ...(semCache ? { Pragma: 'no-cache' } : {}),
        'Accept-Encoding': 'gzip, deflate, br',
        'Accept': 'application/json, text/plain, */*'
      }
    });
    return next(modifiedReq);
  }

  const modifiedReq = req.clone({
    setHeaders: {
      'Accept-Encoding': 'gzip, deflate, br',
      'Accept': 'application/json, text/plain, */*'
    }
  });

  return next(modifiedReq);
};
